import { createActions } from 'reduxsauce'

const { Types, Creators } = createActions({
  fetchOperatorUserList: ['filter', 'offset'],
  fetchOperatorUserListLoading: null,
  fetchOperatorUserListLoadingMore: null,
  fetchOperatorUserListSuccess: ['offset', 'operatorUsers', 'nextOffset'],
  fetchOperatorUserListFail: ['error'],

  updateOperatorUser: ['operatorUserId', 'permissions'],
  updateOperatorUserLoading: null,
  updateOperatorUserSuccess: ['operatorUserId', 'operatorUser'],
  updateOperatorUserFail: ['error'],

  deleteOperatorUser: ['operatorUserId', 'ref'],
  deleteOperatorUserLoading: null,
  deleteOperatorUserSuccess: ['operatorUserId'],
  deleteOperatorUserFail: ['error'],

  unblockOperatorUser: ['operatorUserId'],
  unblockOperatorUserLoading: null,
  unblockOperatorUserSuccess: ['operatorUserId', 'operatorUser'],
  unblockOperatorUserFail: ['error'],

  fetchInviteOperatorUser: ['inviteOperatorUserId'],
  fetchInviteOperatorUserLoading: null,
  fetchInviteOperatorUserSuccess: ['inviteOperatorUser'],
  fetchInviteOperatorUserFail: ['error'],
  setInviteOperatorUserStatus: ['status'],

  fetchInviteOperatorUserList: ['offset'],
  fetchInviteOperatorUserListLoading: null,
  fetchInviteOperatorUserListLoadingMore: null,
  fetchInviteOperatorUserListSuccess: ['invitations', 'nextOffset', 'offset'],
  fetchInviteOperatorUserListFail: ['error'],

  inviteOperatorUser: ['operatorUserData'],
  inviteOperatorUserLoading: null,
  inviteOperatorUserSuccess: ['operatorUser'],
  inviteOperatorUserFail: ['error'],

  deleteInviteOperatorUser: ['inviteOperatorUserId'],
  deleteInviteOperatorUserLoading: null,
  deleteInviteOperatorUserSuccess: ['inviteOperatorUserId'],
  deleteInviteOperatorUserFail: ['error'],

  sendOperatorUserEmail: ['email'],
  sendOperatorUserEmailLoading: null,
  sendOperatorUserEmailSuccess: null,
  sendOperatorUserEmailFail: ['error'],

  createOperatorUser: ['operatorUser'],
  createOperatorUserLoading: null,
  createOperatorUserSuccess: null,
  createOperatorUserFail: ['error'],

  fetchTariffsList: null,
  fetchTariffsListLoading: null,
  fetchTariffsListSuccess: ['tariffs'],
  fetchTariffsListFail: ['error'],

  fetchPrivacySchedule: null,
  fetchPrivacyScheduleLoading: null,
  fetchPrivacyScheduleSuccess: ['PrivacySchedule'],
  fetchPrivacyScheduleFail: ['error'],
  fetchAccessGroupsList: null,
  fetchAccessGroupsListLoading: null,
  fetchAccessGroupsListSuccess: ['accessGroups'],
  fetchAccessGroupsListFail: ['error'],

  fetchOperatorUsersCount: ['filter'],
  fetchOperatorUsersCountLoading: null,
  fetchOperatorUsersCountSuccess: ['count'],
  fetchOperatorUsersCountFail: ['error'],

  fetchOperatorUsersInvitationsCount: null,
  fetchOperatorUsersInvitationsCountLoading: null,
  fetchOperatorUsersInvitationsCountSuccess: ['count'],
  fetchOperatorUsersInvitationsCountFail: ['error'],

  clearOperatorUsers: null,
  clearInvitations: null,

  changePasswordOrName: ['name', 'password', 'onResponse'],
  changePasswordOrNameLoading: null,
  changePasswordOrNameSuccess: null,
  changePasswordOrNameFail: null,
  setChangePasswordOrNameRequestState: ['newRequestState'],

  setClickedOperatorUser: ['rowData'],

  setOperatorUserFilter: ['filter'],
  resetFilters: null,
})

export const OperatorUserTypes = Types
export default Creators
